import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { ThemeProvider } from '@material-ui/core/styles'
import theme from './style/theme.js'
import * as serviceWorker from './serviceWorker';
import { initAnalytics } from './analytics/track';

// Mixpanel: project token by environment plus the web super properties.
// Every other file goes through src/analytics/track.js; nothing else may
// import mixpanel-browser (src/analytics/events.test.js enforces it).
initAnalytics();

console.log('ENV ', process.env.REACT_APP_ENVIRONMENT)
ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
